import styled, {css} from 'styled-components'

const Style = {
	TableDiv: styled.div`
		display: flex;
		flex-direction: column;
		overflow-x: auto;
		width: 100%;

		/* Custom scrollbar styling */
		&::-webkit-scrollbar {
			height: 8px;
		}

		&::-webkit-scrollbar-track {
			background: #f1f1f1;
			border-radius: 4px;
		}

		&::-webkit-scrollbar-thumb {
			background: #c1c1c1;
			border-radius: 4px;

			&:hover {
				background: #a8a8a8;
			}
		}

		/* For Firefox */
		scrollbar-width: thin;
		scrollbar-color: #c1c1c1 #f1f1f1;
	`,
	TableInner: styled.div`
		display: flex;
		flex-direction: column;
		min-width: max-content;
	`,
	TableRow: styled.div`
		min-height: 38px;
		display: flex;
		align-items: center;
		gap: 10px;
		padding: 0 20px;
		cursor: pointer;
		min-width: max-content;
		flex-shrink: 0;

		${({$cursor}) => {
			if ($cursor === 'default')
				return css`
					cursor: default;
				`
		}}

		${({$title}) =>
			$title &&
			css`
				background-color: ${({theme}) => theme.color.major};
				cursor: default;
			`}

		${({$odd}) =>
			$odd &&
			css`
				background-color: ${({theme}) => theme.color.grey1};
			`}

        ${({$break}) =>
			$break &&
			css`
				background-color: ${({theme}) => theme.color.grey3};
			`}

        ${({$expand}) =>
			$expand &&
			css`
				height: fit-content;
			`}
	`,
	Data: styled.div`
		display: flex;
		gap: 4px;
		height: fit-content;
		flex-shrink: 0;
		white-space: normal;
		overflow: visible;
		word-wrap: break-word;
		word-break: break-word;

		${({theme}) => theme.font.extra_small};

		${({$cursor}) => {
			if ($cursor === 'pointer')
				return css`
					cursor: pointer;
				`
		}}

		${({$title}) =>
			$title &&
			css`
				color: ${({theme}) => theme.color.white};
				${({theme}) => theme.font.extra_small_bold};
			`}

		${({$size}) => {
			if ($size === 'short')
				return css`
					width: 50px;
					min-width: 50px;
				`
			else if ($size === 'mediumCenter')
				return css`
					width: 100px;
					min-width: 100px;
					justify-content: center;
				`
			else if ($size === 'mediumUp')
				return css`
					width: 120px;
					min-width: 120px;
				`
			else if ($size === 'long')
				return css`
					width: 150px;
					min-width: 150px;
				`
			else if ($size === 'longCenter')
				return css`
					width: 150px;
					min-width: 150px;
					justify-content: center;
				`
			else if ($size === 'longlong')
				return css`
					width: 200px;
					min-width: 200px;
				`
			else if ($size === 'longlonglong')
				return css`
					width: 250px;
					min-width: 250px;
				`
			else if ($size === 'expand')
				return css`
					flex-grow: 1;
					flex-basis: 0;
					min-width: 0;
				`
			else
				return css`
					width: 100px;
					min-width: 100px;
				`
		}}
        
		${({$break}) =>
			$break &&
			css`
				color: ${({theme}) => theme.color.white};
				${({theme}) => theme.font.extra_small_bold};
			`}

		${({$align}) => {
			if ($align === 'right')
				return css`
					justify-content: flex-end;
				`
		}}
	`,

	Count: styled.div`
		padding: 8px 0;
		& > p {
			margin: 4px 0;
		}
		& > p,
		span {
			${({theme}) => theme.font.extra_small};
		}
	`,
}

export default Style
